import auth from '../config/firebase';
import { getCookie } from '../cookies';
import apiClient from './axiosClient';
import DeleteSeekerConnectionResponse from 'wwg-utilities/dist/dtos/delete-seeker-connection.response';

const deleteTrainingConnectionRequest = async (
  id: string,
  programId: string,
): Promise<DeleteSeekerConnectionResponse> => {
  const token = (await auth.currentUser?.getIdToken()) || getCookie('token');

  return apiClient
    .delete(`seeker-connections/${id}/${programId}`, {
      headers: {
        'Authorization-WWG': `Bearer ${token}`,
      },
    })
    .then((res) => res.data);
};

export default deleteTrainingConnectionRequest;
